<template>
    <button class=" px-[42px] py-3 bg-zinc-800 hover:bg-zinc-900 rounded-[100px] text-white text-sm font-medium leading-none justify-center items-center gap-2 inline-flex">
        <slot/>
    </button>
</template>
